import React, {useState,useMemo} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import OverrideInput from './OverrideInput';
import MultiLines from './MultiLines';

import {Inc,Owner,Override,OverrideSearchCondition,Dataset} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Loading from './Loading';
import Alert from './Alert';
import Yesno from './Yesno';
import Toast from './Toast';
import OverrideListSearch from './OverrideListSearch';
import Title from './Title';

interface OverrideListProps {
	owner:Owner,
	managerId:number,
}
//let p:number = 1;

const OverrideList = (props:OverrideListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defOverrides:Override[] = [];
	const defCheckedIds:number[] = [];

	const [states,setStates] = useState({
        overrides:defOverrides,
		overrideId:0,
		checkedIds:defCheckedIds,
		selectedItemOverrideId:0,
		allChecked:false,
        isLoading:true,
		currentPage:1,
        pager:null,
		yesno:"",
		alert:"",
		ver:0,
        cond:Inc.defaultOverrideSearchCondition(),
    });
	const [toast,setToast] = useState('');
    const search = (cond:OverrideSearchCondition,page:number)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true,"selectedItemOverrideId":0});
        // if( first ){
        //     p = 1;
        // }
        window.scrollTo(0,0);
        Ajax.search("override/list",cond,page,(res:any)=>{
			console.log(res);
            if( res.ok ){
                setStates({...states,overrides:res.overrides,cond:cond,currentPage:page,pager:res.pager,isLoading:false,checkedIds:defCheckedIds,allChecked:false,selectedItemOverrideId:0,yesno:""});
            } else {
                setStates({...states,"isLoading":false,"selectedItemOverrideId":0});
            }
        });
    }
	const jump = (newPage:number)=>{
		//send(values,p);
		//p = newPage;
		search(states.cond,newPage);
    }
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids,ver:states.ver+1});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id),ver:states.ver+1});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false,ver:states.ver+1});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.overrides.length ; i++ ){
				if(states.overrides[i].status==="1") {
					ids.push( states.overrides[i].item_override_id );
				}
			}
			setStates({...states,"checkedIds":ids,"allChecked":true,ver:states.ver+1});
		}
	}
	const yes = ()=>{
		if( states.yesno==="remove" ){
			Ajax.send("override/remove",{override_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
		if( states.yesno==="removeone" ){
			Ajax.send("override/removeone",{override_id:states.overrideId},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	const closeToast = ()=>{
		setToast('');
	}
	const confirmRemove = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"シークレットを選択して下さい"});
		} else {
			setStates({...states,"yesno":"remove"});
		}
	}
	const confirmRemoveOne = (overrideId:number)=>{
		//console.log("remove one",overrideId);
		setStates({...states,"yesno":"removeone",overrideId:overrideId});
	}
    const openInput = (overrideId:number)=>{
        //console.log("openInput",overrideId);
        setStates({...states,"selectedItemOverrideId":overrideId});
    }
    const closeInput = (updated:boolean)=>{
		if( updated ){
			search(states.cond,1);
		} else {
        	setStates({...states,"selectedItemOverrideId":0});
		}
    }
	const OverrideRow = (pr:{override:Override,owner_id:number,index:number})=>{
		const [rowstate,setRowstate] = useState({open:false});
		const toggle = async ()=>{
			setRowstate({...rowstate,open:!rowstate.open});
		}
		let status = "販売中";
		if(pr.override.status==="0"){
			status = "休止中";
		}
		const v = states.checkedIds.includes(pr.override.item_override_id);
		const url = 'https://store.retro-biz.com/items/'+pr.override.item_id;

		//console.log(pr.override);

		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellDense} style={{width:'2em'}}>
					<Checkbox
						checked={v}
						value={String(pr.override.item_override_id)}
						onClick={()=>checkId(pr.override.item_override_id)}
						color="primary"
						className={classes.listCheckbox}
					/>
				</TableCell>
				<TableCell className={classes.tableCellDense} align="center" style={{width:'80px'}} sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}><StoreImg owner_id={props.owner.owner_id} img_id={pr.override.img_id} thumb={true} className="imgList"/></TableCell>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{pr.override.item_id}</span>{String(pr.override.status)==="0" && <span style={{color:'red',marginLeft:'0.5rem',fontSize:'90%'}}>保留・下書き</span>}
					<br/>
					{pr.override.item_name}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="center" style={{width:'5em'}} sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>
					{pr.override.event_name}<br/>{pr.override.event_start}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right" style={{width:'2em'}}><IconButton style={{margin:'0',padding:'0'}} onClick={toggle}><ArrowDropDownIcon/></IconButton></TableCell>
			</TableRow>
			{rowstate.open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '3em', paddingTop: 0, paddingLeft: '0em', paddingRight: 0}} colSpan={9}>
					<Table>
						<TableBody>
							<TableRow sx={{display:{lg:'none',md:'none',sm:'none',xs:'table-row'}}}>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									イベント
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{pr.override.event_name}<br/>{pr.override.event_start}
								</TableCell>
							</TableRow>
							{pr.override.targets?.includes("img_id") &&
							<TableRow sx={{display:{lg:'none',md:'none',sm:'none',xs:'table-row'}}}>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									メイン画像
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									<StoreImg owner_id={props.owner.owner_id} img_id={pr.override.img_id} thumb={false} className="imgItemLarge"/>
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("item_guide") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									紹介文
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
								{pr.override.guides.map((guide:Dataset,index:number)=>{
									const key = "guide"+index;
									return (
										<div key={key}>
										{guide.id!=='' &&
											<h3 style={{fontSize:'120%',color:'#000000'}}>{guide.id}</h3>
										}
										{guide.label!=='' &&
											<div style={{margin:'0',padding:'0',marginBottom:'3em',color:'#222222'}}><MultiLines text={guide.label}/></div>
										}
										</div>
									)
								})}
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("promo_text") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									ショートコピー
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{pr.override.promo_text}
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("thankyou") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									サンキューメッセージ
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{pr.override.thankyou}
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("unit") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									単位
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{pr.override.unit}
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("price") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									価格
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{Tools.comma(pr.override.price)}円（税込）
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("page_id") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									シリーズ
								</TableCell>
								<TableCell sx={{fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									{(!pr.override.page_name || pr.override.page_name==="") ? <span>なし</span> : <><span style={{marginRight:'0.5em'}}>ID:{pr.override.page_id}</span><span>{pr.override.page_name}</span></>}
								</TableCell>
							</TableRow>}
							{pr.override.targets?.includes("photo_ids") &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'},fontSize:{xs:'0.8rem',sm:'1.0rem'}}}>
									ギャラリー
								</TableCell>
								<TableCell>
									<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
								{pr.override.photo_ids && pr.override.photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+index;
									return (
										<div key={key} style={{ flex: '0 0 auto' }}>
											<StoreImg
												owner_id={props.owner.owner_id}
												img_id={img_id}
												thumb={true}
												className="imgItemPhoto"
											/>
										</div>
									);
								})}
								{(!pr.override.photo_ids || pr.override.photo_ids.length===0) && <span>なし</span>}
									</div>
								</TableCell>
							</TableRow>}
						</TableBody>
					</Table>
					<Box sx={{ marginTop:'0.5em', display: 'flex',justifyContent: 'space-between' }}>
						<Button variant="text" size="small" color="error" onClick={()=>confirmRemoveOne(pr.override.item_override_id)}><DeleteForeverIcon/>削除</Button>
						<Button variant="outlined" size="small" color="primary" onClick={()=>openInput(pr.override.item_override_id)}><EditIcon/>修正</Button>
					</Box>
				</TableCell>
			</TableRow>
			}
			</>
		);
	}

	const overrideRows = useMemo(()=>{
		return states.overrides.map((override:Override,index:number)=>{
			const key = "consign"+index;
			return <OverrideRow override={override} owner_id={props.owner.owner_id} index={index} key={key}/>
		})
	},[states.overrides,states.ver])


	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択したオーバーライドを削除します。\nよろしいですか？";
		}
		if( states.yesno==="removeone" ){
			yesnoMes = "このオーバーライドを削除します。\nよろしいですか？";
		}
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

    return (
		<div id="override_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="オーバーライド（期間限定設定）" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
                            特定のイベントの期間中だけ商品名や画像などの商品情報を一時的に上書き（オーバーライド）することができます。<br/>
                            新たにオーバーライドを登録するには、「オーバーライドを登録」をクリックして商品を選択してください。<br/>
							<Hidden mdUp implementation="js">
								<FormControl fullWidth={true} style={{margin:"1em 0", display: "flex", alignItems: "flex-end"}}>
									<Link to="/override/items"><Button variant="contained" color="primary" style={{whiteSpace:"nowrap"}}><AddIcon/>オーバーライドを登録</Button></Link>
								</FormControl>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>
									</TableCell>

                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>画像</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">商品名</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>イベント</TableCell>
									<TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
							<TableBody>{overrideRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・削除" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Link to="/override/items"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>オーバーライドを登録</Button></Link>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックしたオーバーライドを</div>
							<Button variant="contained" color="secondary" size="small" onClick={confirmRemove} disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
						</FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>
								イベントの開催中にオーバーライドを変更または削除すると、イベントの参加条件に影響を及ぼす可能性があります。
							</li>
                        </ul>
						<div style={{textAlign:'right'}}>
							<a href="https://tron.retro-ink.com/quaqoostore/100fes-1" target="_blank"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>架空の百年祭とは</Button></a>
						</div>
					</Paper>

                    <Paper className={classes.paper}>
                        <OverrideListSearch update={search}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<OverrideInput itemOverrideId={states.selectedItemOverrideId} isOpen={states.selectedItemOverrideId>0} owner={props.owner} managerId={props.managerId} close={closeInput}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default OverrideList;
